import ActionButton from "#/components/buttons/ActionButton";
import BaseTable from "#/components/tables/BaseTable";
import { useClient } from "#/hook/useClient";
import type { HawbItemRow } from "#/types/manifest";
import { formatDateTime } from "#/utils/dateTimeUtils";
import { sanitizeItemStatusLabel } from "#/utils/StringUtils";
import { Table } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface HawbItemsTableProps {
  items: HawbItemRow[];
}

/** Every package item of the consignment; a row opens the item. */
const HawbItemsTable = ({ items }: HawbItemsTableProps) => {
  const { t } = useTranslation();
  const { client } = useClient();
  const navigate = useNavigate();

  return (
    <BaseTable
      headers={[
        t("manifests.detail.columns.item"),
        t("manifests.detail.columns.rfid"),
        t("common.status"),
        t("manifests.detail.columns.lastScan"),
        t("common.actions"),
      ]}
      rows={items.map((item) => (
        <Table.Tr
          key={item.id}
          className="cursor-pointer"
          onClick={() => void navigate(`/inventory/items/${item.id}`)}
        >
          <Table.Td className="min-w-[200px]">{item.external_id ?? `#${item.id}`}</Table.Td>
          <Table.Td className="min-w-[220px]">
            {item.rfid_tags.length > 0 ? (
              item.rfid_tags.map((tag) => tag.rfid).join(", ")
            ) : (
              <span className="text-gray-500">{t("manifests.detail.notTagged")}</span>
            )}
          </Table.Td>
          <Table.Td>{item.status ? sanitizeItemStatusLabel(item.status) : "--"}</Table.Td>
          <Table.Td className="min-w-[160px]">{formatDateTime(item.last_scan, client)}</Table.Td>
          <Table.Td className="min-w-[80px]">
            <div className="w-full flex items-center justify-center">
              <ActionButton
                icon={IconEye}
                variant="outline"
                onClick={(e) => {
                  e.stopPropagation();
                  void navigate(`/inventory/items/${item.id}`);
                }}
              />
            </div>
          </Table.Td>
        </Table.Tr>
      ))}
    />
  );
};

export default HawbItemsTable;
